// extracted by mini-css-extract-plugin
export default {"userListSection":"userList_userListSection__kJfdv"};